import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-foreground-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="py-14 md:py-20 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2.5 mb-4">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-trophy-line text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-lg font-semibold text-foreground-50">
                每日大赛
              </span>
            </div>
            <p className="text-sm text-foreground-300 leading-relaxed">
              每天参与竞技赢取丰厚奖励。每日大赛是您每天不可错过的竞技盛宴，与全国玩家同台竞技，赢取丰厚奖品与荣耀积分。
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a href="#" className="w-9 h-9 rounded-lg bg-foreground-800 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-foreground-200"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-lg bg-foreground-800 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-foreground-200"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-lg bg-foreground-800 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer" aria-label="抖音">
                <i className="ri-tiktok-line text-foreground-200"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-50 mb-5">
              赛事分类
            </h4>
            <ul className="space-y-3">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-300 hover:text-primary-400 transition-colors flex items-center gap-2"
                  >
                    <i className={`${cat.icon} text-xs`}></i>
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-50 mb-5">
              快速链接
            </h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors">
                  关于我们
                </Link>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors">
                  赛事规则
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors">
                  积分商城
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors">
                  常见问题
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors">
                  用户协议
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-50 mb-5">
              联系我们
            </h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2.5 text-sm text-foreground-300">
                <i className="ri-mail-line mt-0.5 text-foreground-400"></i>
                <span>contact@meiridasai.com</span>
              </li>
              <li className="flex items-start gap-2.5 text-sm text-foreground-300">
                <i className="ri-phone-line mt-0.5 text-foreground-400"></i>
                <span>400-888-9999</span>
              </li>
              <li className="flex items-start gap-2.5 text-sm text-foreground-300">
                <i className="ri-map-pin-line mt-0.5 text-foreground-400"></i>
                <span>北京市朝阳区建国路88号SOHO现代城A座</span>
              </li>
              <li className="flex items-start gap-2.5 text-sm text-foreground-300">
                <i className="ri-time-line mt-0.5 text-foreground-400"></i>
                <span>周一至周五 9:00-18:00</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-foreground-800 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} 每日大赛 版权所有 | 京ICP备2024XXXXXXXX号
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-200 transition-colors">隐私政策</a>
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-200 transition-colors">服务条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}